import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { BsEnvelope, BsPerson, BsChatDots } from 'react-icons/bs';
import { toast } from 'react-toastify';
import { getApiUrl } from '../config/api';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const API_URL = getApiUrl('CONTACT');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        toast.success('Message sent successfully! We\'ll get back to you soon.');
        // Reset form
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        toast.error(data.message || 'Failed to send message. Please try again.');
      }
    } catch (error) {
      toast.error('Error sending message. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header onShowInterest={() => {}} />
      <section className="contact-page">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} xl={7}>
              <div className="contact-header text-center mb-5">
                <h1 className="contact-title">Get in Touch</h1>
                <p className="contact-subtitle">
                  Have a question or feedback? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
                </p>
              </div>

              <div className="contact-form-card">
                <Form onSubmit={handleSubmit}>
                  {/* Name */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label-compact">Full Name</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text bg-white border-end-0">
                        <BsPerson size={18} />
                      </span>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter your full name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className="border-start-0 ps-0"
                        required
                      />
                    </div>
                  </Form.Group>

                  {/* Email */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label-compact">Email Address</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text bg-white border-end-0">
                        <BsEnvelope size={18} />
                      </span>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="border-start-0 ps-0"
                        required
                      />
                    </div>
                  </Form.Group>

                  {/* Subject */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label-compact">Subject</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text bg-white border-end-0">
                        <BsChatDots size={18} />
                      </span>
                      <Form.Control
                        type="text"
                        name="subject"
                        placeholder="What is this about?"
                        value={formData.subject}
                        onChange={handleInputChange}
                        className="border-start-0 ps-0"
                      />
                    </div>
                  </Form.Group>

                  {/* Message */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label-compact">Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={6}
                      name="message"
                      placeholder="Tell us more about your inquiry..."
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                    />
                  </Form.Group>

                  {/* Submit Button */}
                  <div className="d-grid">
                    <Button 
                      variant="primary" 
                      type="submit" 
                      className="btn-submit-compact"
                      disabled={loading}
                      style={{ padding: '12px', fontSize: '16px' }}
                    >
                      {loading ? 'Sending...' : 'Send Message'}
                    </Button>
                  </div>
                </Form>
              </div>

              {/* Contact Info */}
              <div className="contact-info text-center mt-5">
                <p className="mb-2">
                  <strong>Email:</strong>{' '}
                  <a href="mailto:support@nisa-care.com" style={{ color: '#008080' }}>
                    support@nisa-care.com
                  </a>
                </p>
                <p className="text-muted small">
                  We typically respond within 24-48 hours
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default ContactPage;